export const MatchingLabel = Object.freeze({
    UNDETECTED: 'undetected',
    DARK_VESSEL: 'dark_vessel',
    MATCHED: 'matched',
} as const);
export type MatchingLabelKeys = keyof typeof MatchingLabel;
export type MatchingLabelValues = typeof MatchingLabel[keyof typeof MatchingLabel];

export const ImageSource = Object.freeze({
    SENTINEL2: 'sentinel2',
    PLANET_SCOPE: 'planet_scope',
} as const);
export type ImageSourceKeys = keyof typeof ImageSource;
export type ImageSourceValues = typeof ImageSource[keyof typeof ImageSource];

export const ObjectClass = Object.freeze({
    SHIP: 'ship',
    WINDMILL: 'windmill',
    PLATFORM: 'platform',
} as const);
export type ObjectClassKeys = keyof typeof ObjectClass;
export type ObjectClassValues = typeof ObjectClass[keyof typeof ObjectClass];
